import angular from 'angular';
import moment from 'moment';
import URLS from 'Helpers/urls';

(function() {
    'use strict';

    angular.module('app').component('teacherPickerModal', {
        template: require('./teacher-modal.html'),
        controller: TeacherPickerModalCtrl,
        controllerAs: 'vm',
        bindings: {
            modalInstance: '<',
            resolve: '<'
        }
    });

    TeacherPickerModalCtrl.$inject = [
        '$scope',
        '$cookies',
        '$timeout',
        'QueryService'
    ];

    function TeacherPickerModalCtrl($scope, $cookies, $timeout, QueryService) {
        var vm = this;
        vm.content = null;

        vm.scheduled_date = moment().utcOffset('+9:00');


        vm.approve = approve;
        vm.cancel = cancel;
        vm.getClass = getClass;
        vm.confirm = confirm;

        vm.data = {};
        vm.titles = [
            '아래는 선생님의 수업 가능 시간표입니다. "체험수업 일정"을 선택해주세요.',
            '아래는 선생님의 수업 가능 시간표입니다. "정규수업 일정"을 선택해주세요.',
            'Summary'];
        vm.page = 1;


        vm.$onInit = function() {
            vm.content = angular.copy(vm.resolve.content);
            vm.coupon_code = vm.content.coupon_code;

            if(vm.coupon_code){
                vm.allowed_teacher_count = 2;
            }else{
                vm.allowed_teacher_count = 3;
            }
            
            vm.teacher = vm.content.teacher;
            vm.teacher_count = vm.content.teacher_count;
            getScheduleRegular();
        };

        vm.tomorrow = false;
        vm.start_hour = 6;
        vm.end_hour = 25;
        vm.hour_divisions = 4;

        vm.minutes_increment = 60 / vm.hour_divisions;
        
        vm.days = [1, 2, 3, 4, 5];
        vm.regular_hours = [];
        for (
            let i = vm.start_hour * vm.hour_divisions;
            i < vm.end_hour * vm.hour_divisions;
            i++
        ) {
            vm.regular_hours.push(i);
        }
        function move_scheduled_date(){
            vm.scheduled_date = new Date();
            //set to next monday if weekend
            if(vm.scheduled_date.getDay() === 6){
                vm.scheduled_date.setDate(vm.scheduled_date.getDate()+2);
            } else
            if(vm.scheduled_date.getDay() === 5){
                vm.scheduled_date.setDate(vm.scheduled_date.getDate()+3);
            }else{
                vm.scheduled_date.setDate(vm.scheduled_date.getDate() + 1);
            }
            while(vm.scheduled_date.getDay() === 0 || vm.scheduled_date.getDay() === 6 || vm.disabled_dates.includes(vm.scheduled_date.format('mm-dd'))){
                vm.scheduled_date.setHours(vm.scheduled_date.getHours()+24);
            }
            getSchedule();

        }

        //get limits
        console.log('Getting Limits');
        vm.loading = true;
        var request = {
            method: 'GET',
            body: false,
            params: { date: new Date().format('yyyy-mm-dd')},
            hasFile: false,
            route: URLS.base + `/demo_class_limit`,
            cache: false
        };

        QueryService.query(request)
            .then(
                function(response) {
                    const data = response.data.data.disabled_dates.map(s => s.date);
                    vm.disabled_dates = data;
                    move_scheduled_date();
                    console.log(data);
                },
                function(error) {
                    // logger.errorFormatResponse(error);
                }
            )
            .finally(function() {
                vm.loading = false;
            });
        //end get limits

        vm.clicked_dates = [];

        vm.hours = [];
        for (let i = vm.start_hour; i < vm.end_hour; i++) {
            vm.hours.push(i);
        }

        vm.minutes = [];
        for (let i = 0; i < vm.hour_divisions; i++) {
            vm.minutes.push(vm.minutes_increment * i);
        }

        vm.set_tomorrow = function(val) {
            vm.tomorrow = val;
        };

        
        getLimit();
        function getLimit() {
            vm.limit_loaded = false;
            vm.loading = true;
            var request = {
                method: 'GET',
                body: false,
                params: { date: new Date().format('yyyy-mm-dd')},
                hasFile: false,
                route: URLS.base + `/demo_class_limit`,
                cache: false
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        const data = response.data.data;
                        vm.demo_count = data.count;
                        vm.demo_limit = data.limit;
                        vm.limit_loaded = true;
                    },
                    function(error) {
                        // logger.errorFormatResponse(error);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                });
        }


        vm.getSchedule = getSchedule;
        function getSchedule() {
            
            vm.loading = true;
            var request = {
                method: 'GET',
                body: false,
                params: false,
                hasFile: false,
                route:
                    URLS.base +
                    `/schedule/${new Date(vm.scheduled_date).getDay()}/${vm.content
                        .mode === 'single'
                        ? 2
                        : 1}/available/teacher/${vm.teacher.id}`,

                // route: URLS.base + `/schedule/1/available/teacher/${vm.teacher.id}`,
                cache: false
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        vm.available_schedule = response.data.data.items;
                    },
                    function(error) {
                        // logger.errorFormatResponse(error);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                });
        }

        function approve(hour, minute) {
            let tomorrow = new Date();
            let this_date = new Date(vm.scheduled_date);

            tomorrow.setHours(tomorrow.getHours() + 24);
            this_date.setHours(hour);
            this_date.setMinutes(minute);

            const available = vm.available_schedule
                .map(h => {
                    return h.hours;
                })
                .indexOf(hour * 4 + minute / 15);

            if (available < 0 || tomorrow - this_date > 0) {
            } else {
                const c = vm.clicked_dates.filter(x => {
                    return x.hour == hour && x.minute == minute;
                })[0];

                if (c) {
                    const index = vm.clicked_dates.indexOf(c);
                    vm.clicked_dates.splice(index, 1);
                } else if(vm.clicked_dates.length < 1){
                    vm.clicked_dates.push({
                        hour: hour,
                        minute: minute
                    });

                    vm.data.demo_schedule = moment(vm.scheduled_date);
                    vm.data.demo_schedule.utcOffset(9).hour(hour);
                    vm.data.demo_schedule.utcOffset(9).minute(minute);

                    vm.data.demo_schedule_display = new Date(vm.data.demo_schedule);


                    vm.demo_day = moment(vm.scheduled_date).utcOffset(9).day();
                    vm.demo_hour = hour * 4 + minute / 15;
                }
            }

        }

        function getClass(hour, minute) {

            let tomorrow = new Date();
            let this_date = new Date(vm.scheduled_date);

            const day = this_date.getDay();

            tomorrow.setHours(tomorrow.getHours() + 24);
            this_date.setHours(hour);
            this_date.setMinutes(minute);

            if(tomorrow - this_date > 0){
                return 'schedule-unavailable';
            }
            
            const c = vm.clicked_dates.filter(x => {
                return x.hour == hour && x.minute == minute;
            })[0];

            const available = vm.available_schedule.filter(s => s.day===day)
                ? vm.available_schedule
                      .map(h => {
                          return h.hours;
                      })
                      .indexOf(hour * 4 + minute / 15)
                : null;

            return c ? 'clicked_hour' : available >= 0 && (vm.demo_count < vm.demo_limit || !vm.limit_loaded)? 'available' : 'schedule-unavailable';
        }

        vm.getClassRegular = (hour, day) => {
            let class_string = '';
            const c = vm.available_schedule_regular.filter(x => {
                return x.hour == hour && x.day == day;
            })[0];

            // const c = 1;

            const available = vm.clicked_dates.filter(h => {
                return h.hour == hour && h.day == day;
            });

            //same hour
            // if (
            //     vm.clicked_dates.length > 0 &&
            //     vm.clicked_dates[0].hour !== hour
            // ) {
            //     class_string += 'regular_class_disabled ';
            // }

            if (vm.clicked_dates.indexOf(available[0]) >= 0) {
                return class_string + 'clicked_hour';
            } else {
                return (
                    class_string + (c ? 'available' : 'schedule-unavailable')
                );
            }
        };

        vm.getScheduleRegular = getScheduleRegular;
        function getScheduleRegular() {
            vm.loading = true;
            var request = {
                method: 'GET',
                body: false,
                params: false,
                hasFile: false,
                route: URLS.base + `/schedule/1/available/teacher/${vm.teacher.id}`,
                cache: false
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        vm.available_schedule_regular = response.data.data.items;
                    },
                    function(error) {
                        // logger.errorFormatResponse(error);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                });
        }

        vm.approve_regular = (hour, day) => {

            const available = vm.available_schedule_regular.filter(h => {
                return h.hour === hour && h.day === day;
            })[0];

            // if (
            //     vm.clicked_dates.length > 0 &&
            //     vm.clicked_dates[0].hour !== hour
            // ) {
            // } else 
            if (available) {
                if (vm.clicked_dates.indexOf(available) >= 0) {
                    vm.clicked_dates.splice(
                        vm.clicked_dates.indexOf(available),
                        1
                    );
                } else {
                    vm.clicked_dates.push(available);
                }
            }
        };

        function confirm() {
            const dates = [];

            vm.clicked_dates.forEach(date => {
                var s = new Date(vm.scheduled_date.getTime());

                s = moment(s).utcOffset(9).hour(date.hour);
                s = moment(s).utcOffset(9).minute(date.minute);

                dates.push({
                    date: s,
                    day: s.day(),
                    hour: date.hour * 4 + date.minute / 15
                });
            });

            vm.modalInstance.close(dates);
        }

        function cancel() {
            vm.modalInstance.close();
        }

        vm.disabled = function(date) {
            return date.date.getDay() === 0 || date.date.getDay() === 6 || vm.disabled_dates.includes(date.date.format('mm-dd'));
        };

        vm.date_options = {
            startingDay: 0,
            dateDisabled: vm.disabled
        };

        vm.to_time = function(hour) {
            return (
                ('' + parseInt(hour / vm.hour_divisions)).padStart(2, 0) +
                ':' +
                ('' +
                    hour %
                        vm.hour_divisions *
                        (60 / vm.hour_divisions)).padStart(2, 0)
            );
        };

        vm.to_hour = function(hour) {
            return hour % 4 === 0
                ? `
                    ${'' + parseInt(hour / vm.hour_divisions)}:00
            `
                : '';
        };

        vm.date_opened = false;
        vm.open = function($event) {
            vm.date_opened = true;
        };

        vm.back = ()=>{
            vm.page = 1;
            vm.clicked_dates = [];
        }


        vm.done = (next) => {
            const data = objectify();
            data.finalized = true;
            if(next){
                data.next = true;
                vm.modalInstance.close(data);
            }else{
                data.next = false;
                vm.modalInstance.close(data);
            }
        }

        function _hour_to_hour(hour){
            return parseInt(hour / 4);
        }

        function objectify(){
            return {
                teacher_id: vm.teacher.id,
                demo_schedule: vm.data.demo_schedule,
                demo_schedule_display: vm.data.demo_schedule_display,
                regular_class_schedules: vm.clicked_dates,
                day: vm.demo_day,
                hour: vm.demo_hour,
            };
        }

    }
})();



// WEBPACK FOOTER //
// ./src/app/components/demo-teacher/teacher-modal.component.js